import { useSetState } from '@mantine/hooks';
import React from 'react';
import { useGetIsMounted } from 'rooks';
import { RowContent } from './RowContent';
import { FocusMap, TrProps } from '../types';

export function Tr(props: TrProps) {
  const { cells: content, onClick, ...rest } = props;

  const [hovered, setHovered] = useSetState<FocusMap>({});
  const isMounted = useGetIsMounted();

  const isHovered = Object.values(hovered).some(entry => entry);

  return (
    <tr {...rest} data-hovered={isHovered}>
      {content.map((def, index) => {
        const { node, id } = def;
        return (
          <td key={id}>
            <RowContent
              index={index}
              setHovered={setHovered}
              isParentMounted={isMounted}
              onClick={onClick}
            >
              {node}
            </RowContent>
          </td>
        );
      })}
    </tr>
  );
}
